













































































import Vue from "vue";
import Component from 'vue-class-component';
import {Watch}from 'vue-property-decorator';
import { NcLexer, NcToken } from "@ncstat/parser";
import { Multipane, MultipaneResizer } from "vue-multipane";

const DEMO_INPUT = `%
O1234 (TEST PROGRAM)

N43 ( #14 [.182"] DRILL )
T43 M6
G0 G90 G54 X.75 Y.19
S10495 M3
M50 (TSC COOLANT ON)
G43 H#518 Z1. T44
G98 G81 Z-.5631 R.1 F83.96
X5.
G80
M30
%`;

@Component({
  components: {
    Multipane,
    MultipaneResizer
  }
})
export default class Lexer extends Vue {
  lexer = new NcLexer();

  tab = null;
  input = DEMO_INPUT;
  selectedItem!: string;
  tokens: NcToken[] = [];

  get tokenCount() {
    return this.tokens.length;
  }

  mounted() {
    this.tokenizeInput();
  }

  @Watch('input')
  onInput(val: string, _oldVal: string) {
    this.$emit("input", { input: val });
  }

  // onTokens(newVal) {
  //   this.$emit("token", { tokens: newVal });
  // }

  reset() {
    this.input = "";
    this.tokens = [];
  }

  tokenizeInput(): void {
    const tokens = this.lexer.tokens(this.input);

    console.log(tokens);

    this.tokens = tokens;
  }

  update(input: string) {
    this.input = input.toUpperCase();

    this.tokenizeInput();
  }
}
